import { ITenantConfig } from 'data/tenant-config';
import { sendApiRequest } from 'utils/network';

interface ITenant {
  name: string;
  id: string;
}

interface FetchMarketConfigResult {
  config: ITenantConfig | null;
  allConfigs: ITenantConfig[];
  allFetchedConfigs: ITenantConfig[];
  tenants: ITenant[];
}

export function decodeTenantParam(param: string): string {
  return param === '_default' ? '*' : param;
}

export function encodeTenantParam(tenant: string): string {
  return !tenant || tenant === '*' ? '_default' : tenant;
}

export function mergeConfigUpdates(prev: ITenantConfig, updates: Partial<ITenantConfig>): ITenantConfig {
  return {
    ...prev,
    ...updates,
    flags: updates.flags ? { ...prev.flags, ...updates.flags } : prev.flags,
    sessionTimeout: updates.sessionTimeout
      ? { ...prev.sessionTimeout, ...updates.sessionTimeout }
      : prev.sessionTimeout,
    scheduler: updates.scheduler ? { ...prev.scheduler, ...updates.scheduler } : prev.scheduler,
    accessControl: updates.accessControl ? { ...prev.accessControl, ...updates.accessControl } : prev.accessControl,
  };
}

export async function fetchMarketConfig(
  brand: string,
  market: string,
  tenantId: string
): Promise<FetchMarketConfigResult> {
  const [configs, tenantList] = await Promise.all([
    sendApiRequest<ITenantConfig[]>('/config?brand=*&market=*'),
    sendApiRequest<ITenant[]>('/tenants'),
  ]);

  const allFetchedConfigs = configs ?? [];
  const allConfigs = allFetchedConfigs.filter((c) => c.brand === brand && c.market === market);
  const config =
    allFetchedConfigs.find((c) => c.brand === brand && c.market === market && (c.tenant ?? '*') === tenantId) ?? null;

  return { config, allConfigs, allFetchedConfigs, tenants: tenantList ?? [] };
}
